module.exports = __webpack_public_path__ + "static/media/addUser.16b250b9.svg";